import { useCallback } from "react";

import useAlert from "./useAlert";

export const READ_ONLY_MODE_TITLE = "Sistema en modo consulta";

export const READ_ONLY_MODE_MESSAGE =
  "Desde MAXCORE ya no se permite crear, editar, eliminar, activar, desactivar, aprobar, reportar, referir ni modificar información. Puedes continuar consultando la información existente.";

const useReadOnlyModeGuard = () => {
  const { infoAlert } = useAlert();

  const showReadOnlyModal = useCallback(() => {
    return infoAlert({
      title: READ_ONLY_MODE_TITLE,
      message: READ_ONLY_MODE_MESSAGE,
      confirmBtnMessage: "Entendido"
    });
  }, [infoAlert]);

  const guardReadOnlyAction = useCallback(
    (_actionName?: string, _source?: string) => {
      showReadOnlyModal();
      return false;
    },
    [showReadOnlyModal]
  );

  return {
    showReadOnlyModal,
    guardReadOnlyAction
  };
};

export default useReadOnlyModeGuard;
